import { AllStudentRoleIds, AllUserRoleIds } from "@/constants/userRoles";
// Static imports so these pages are always in the main bundle and available offline
import CheckInternetConnection from "@/views/common/CheckInternetConnection.vue";
import OfflineDownloads from "@/views/common/OfflineDownloads.vue";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "LandingPage" */ "@/views/common/LandingPage.vue"),
    name: "LandingPage",
    meta: {
      requiresUnAuth: true,
      scrollToTop: true,
      excludeNavbar: true,
      showAppFooter: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  { path: "/home", redirect: "/" },
  {
    // usermgmt-8-1 — repurposed the former "/register"→"/" stub. requiresUnAuth (no allowedRoleIds
    // gate, OQ-36): authenticated users are redirected to their dashboard by router.beforeEach.
    path: "/register/b2c",
    component: () =>
      import(/* webpackChunkName: "B2cRegistration" */ "@/views/common/B2cRegistration.vue"),
    name: "B2cRegistration",
    meta: {
      requiresUnAuth: true,
      scrollToTop: true,
      excludeNavbar: true,
      showAppFooter: true,
    },
  },
  { path: "/login", redirect: "/" },
  {
    path: "/change-password",
    component: () =>
      import(/* webpackChunkName: "Unauthorized" */ "@/views/common/ChangePassword.vue"),
    name: "ChangePassword",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/login-redirect",
    component: () =>
      import(/* webpackChunkName: "LoginRedirect" */ "@/views/common/LoginRedirect.vue"),
    name: "LoginRedirect",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      excludeNavbar: true,
      showAppFooter: true,
      allowedRoleIds: AllStudentRoleIds,
    },
  },
  {
    path: "/logout/:isSystemExpired?",
    component: () => import(/* webpackChunkName: "LandingPage" */ "@/views/common/Logout.vue"),
    name: "Logout",
    meta: {
      // Deliberately NOT auth-gated. gotoLogout() clears the credentials before it routes here,
      // so an auth-gated logout page would bounce to LandingPage (or, for a role the current
      // build no longer recognises, to Unauthorized) and the teardown in Logout.vue — expiring
      // the server session, clearing offline downloads, resetting the stores — would never run.
      requiresAuth: false,
      scrollToTop: true,
      excludeNavbar: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/resource-not-found",
    component: () =>
      import(/* webpackChunkName: "ResourceNotFound" */ "@/views/common/ResourceNotFound.vue"),
    name: "ResourceNotFound",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      showAppFooter: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/student-activity-report/:activityInstanceId",
    component: () =>
      import(
        /* webpackChunkName: "StudentActivityReport" */ "@/views/common/StudentActivityReport.vue"
      ),
    name: "StudentActivityReport",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/student-self-practice-report/:selfPracticeId",
    component: () =>
      import(
        /* webpackChunkName: "StudentSelfPracticeReport" */ "@/views/common/StudentSelfPracticeReport.vue"
      ),
    name: "StudentSelfPracticeReport",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/unauthorized",
    component: () =>
      import(/* webpackChunkName: "Unauthorized" */ "@/views/common/Unauthorized.vue"),
    name: "Unauthorized",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/under-maintenance",
    component: () =>
      import(/* webpackChunkName: "UnderMaintenance" */ "@/views/common/UnderMaintenance.vue"),
    name: "UnderMaintenance",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      showAppFooter: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/check-internet-connection",
    component: CheckInternetConnection,
    name: "CheckInternetConnection",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      showAppFooter: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/too-many-requests",
    component: () =>
      import(/* webpackChunkName: "TooManyRequests" */ "@/views/common/TooManyRequests.vue"),
    name: "TooManyRequests",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/qr-code-scanner",
    component: () =>
      import(/* webpackChunkName: 'QrCodeScanner' */ "@/views/common/QrCodeScanner.vue"),
    name: "QrCodeScanner",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/qr-code/:qrCode",
    component: () =>
      import(
        /* webpackChunkName: 'QrCodeContentViewer' */ "@/views/common/QrCodeContentViewer.vue"
      ),
    name: "QrCodeContentViewer",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/olympiad-syllabus",
    component: () =>
      import(/* webpackChunkName: 'OlympiadSyllabus' */ "@/views/olympiad/OlympiadSyllabus.vue"),
    name: "OlympiadSyllabus",
    meta: {
      requiresAuth: false,
      scrollToTop: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
  {
    path: "/offline-downloads",
    component: OfflineDownloads,
    name: "OfflineDownloads",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowOffline: true,
      allowedRoleIds: AllUserRoleIds,
    },
  },
] as unknown as Array<RouteRecordRaw>;
